import { render, staticRenderFns } from "./DivisionsMetrics.vue?vue&type=template&id=def05c42&"
import script from "./DivisionsMetrics.vue?vue&type=script&setup=true&lang=js&"
export * from "./DivisionsMetrics.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports